import { render, staticRenderFns } from "./LpSetting.vue?vue&type=template&id=06f1b671&"
import script from "./LpSetting.vue?vue&type=script&lang=ts&"
export * from "./LpSetting.vue?vue&type=script&lang=ts&"
import style0 from "./LpSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports